import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2, Mail } from 'lucide-react';
import SharedHeader from './SharedHeader';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No verification token provided. Check your email for the correct link.');
      return;
    }

    const verify = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
        const resp = await fetch(`${baseUrl}/api/auth/verify-email?token=${encodeURIComponent(token)}`);
        const data = await resp.json();
        if (resp.ok) {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully!');
        } else {
          setStatus('error');
          setMessage(data.detail || 'Verification failed. The link may be invalid or expired.');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Could not connect to the server. Please try again later.');
      }
    };
    verify();
  }, [token]);

  return (
    <div className="min-h-screen" style={{ background: '#0a1525' }}>
      <SharedHeader />
      <div className="pt-24 flex items-center justify-center p-4">
        <div className="w-full max-w-md bg-slate-900/80 backdrop-blur-md rounded-2xl shadow-xl border border-slate-700/50 p-8 text-center">
        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-600 to-cyan-400 flex items-center justify-center mx-auto mb-6">
          <Mail className="w-7 h-7 text-white" />
        </div>

        {status === 'loading' && (
          <>
            <Loader2 className="w-10 h-10 text-blue-400 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">Verifying your email...</h2>
            <p className="text-slate-400 text-sm">Please wait a moment.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle2 className="w-12 h-12 text-green-400 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">Email Verified!</h2>
            <p className="text-slate-400 text-sm mb-6">{message}</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
            >
              Go to Dashboard
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-white mb-2">Verification Failed</h2>
            <p className="text-slate-400 text-sm mb-6">{message}</p>
            <button
              onClick={() => navigate('/')}
              className="w-full py-3 bg-slate-700 hover:bg-slate-600 text-white rounded-lg font-medium transition-colors"
            >
              Back to Home
            </button>
          </>
        )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
